import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import './AppShell.css';

export function AppShell() {
  return (
    <div className="app-shell">
      <TopNav />
      <Outlet />
    </div>
  );
}
